module.exports = __webpack_public_path__ + "assets/c901ad5f-a842-4549-a1f4-583a97f7e169.4a148843.svg";